const LinkedInIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 19) / 18}
        viewBox='0 0 18 19'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.82345 6.63763H5.09939V17.584H1.82345V6.63763ZM3.44137 1.08398C4.53335 1.08398 5.42284 1.96914 5.42284 3.0558C5.42284 4.14245 4.53335 5.02761 3.44137 5.02761C2.34939 5.02761 1.5 4.14245 1.5 3.0558C1.5 1.96914 2.34939 1.08398 3.44137 1.08398ZM7.04076 6.63763H10.2759V8.16718C10.9636 7.161 12.0957 6.51725 13.3901 6.51725H14.2796C16.342 6.51725 18 8.20774 18 10.2195V17.584H14.7648V16.5778V11.6679C14.7241 10.4203 13.8753 9.45469 12.6216 9.45469C11.3679 9.45469 10.3167 10.4203 10.2759 11.6679V17.584H7.04076V6.63763Z'
        />
      </svg>
    </span>
  );
};

export default LinkedInIcon;
